import type { Step } from "react-joyride";

export const settingsFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຟອມຕັ້ງຄ່າຄ່າສົ່ງ. ເລືອກໂຊນເລີ່ມຕົ້ນ ແລະ ນ້ຳໜັກ variant ເລີ່ມຕົ້ນ (ກຣາມ).",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="shipping-settings-default-zone"]',
    content:
      "ໂຊນເລີ່ມຕົ້ນ — ໃຊ້ເມື່ອບໍ່ມີໂຊນຈາກແຂວງທີ່ເລືອກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-settings-variant-weight"]',
    content:
      "ນ້ຳໜັກ variant ເລີ່ມຕົ້ນ (ກຣາມ) — ໃຊ້ເມື່ອ variant ບໍ່ມີນ້ຳໜັກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-settings-submit"]',
    content:
      "ກົດ 'ບັນທຶກ' ເພື່ອບັນທຶກ ຫຼື 'ຍົກເລີກ' ເພື່ອກັບຄືນ.",
    placement: "top",
  },
];
